const graphData = {
  characters: {
    center: {
      id: 'center',
      name: 'center',
      cx: 60,
      cy: 60,
      opacity: 0,
      scale: 0.001,
    },
    queen: {
      id: 'queen',
      name: 'Királynő',
      gender: 'female',
      color: 'pink',
      imageX: 0,
      imageY: 0,
      imageWidth: 100,
      imageHeight: 100,
      cx: 22.5,
      cy: 37.5,
      scale: 0.3,
      opacity: 0,
    },
    snowwhite: {
      id: 'snowwhite',
      name: 'Hófehérke',
      gender: 'female',
      color: 'pink',
      imageX: 0,
      imageY: 0,
      imageWidth: 100,
      imageHeight: 100,
      cx: 52.5,
      cy: 67.5,
      scale: 0.3,
      opacity: 0,
    },
    witch: {
      id: 'witch',
      name: 'Mostoha',
      gender: 'female',
      color: 'pink',
      imageX: -4,
      imageY: 20,
      imageWidth: 120,
      imageHeight: 120,
      cx: 15,
      cy: 15,
      scale: 0.3,
      opacity: 0,
    },
    king: {
      id: 'king',
      name: 'Király',
      gender: 'male',
      color: 'skyblue',
      imageX: -18,
      imageY: 25,
      imageWidth: 140,
      imageHeight: 140,
      cx: 60,
      cy: 60,
      scale: 0.75,
      opacity: 1,
    },
    prince: {
      id: 'prince',
      name: 'Herceg',
      gender: 'male',
      color: 'skyblue',
      imageX: 25,
      imageY: 10,
      imageWidth: 50,
      imageHeight: 100,
      cx: 67.5,
      cy: 52.5,
      scale: 0.3,
      opacity: 0,
    },
    huntsman: {
      id: 'huntsman',
      name: 'Vadász',
      gender: 'male',
      color: 'skyblue',
      imageX: 25,
      imageY: 10,
      imageWidth: 50,
      imageHeight: 100,
      cx: 97.5,
      cy: 82.5,
      scale: 0.3,
      opacity: 0,
    },
    witch2: {
      id: 'witch',
      name: 'Mostoha',
      gender: 'female',
      color: 'pink',
      imageX: -4,
      imageY: 20,
      imageWidth: 120,
      imageHeight: 120,
      cx: 15,
      cy: 85,
      scale: 0.3,
      opacity: 0,
    },
    queen2: {
      id: 'queen',
      name: 'Királynő',
      gender: 'female',
      color: 'pink',
      imageX: 0,
      imageY: 0,
      imageWidth: 100,
      imageHeight: 100,
      cx: 22.5,
      cy: 37.5,
      scale: 0.3,
      opacity: 0,
    },
    king2: {
      id: 'king',
      name: 'Király',
      gender: 'male',
      color: 'skyblue',
      imageX: -18,
      imageY: 25,
      imageWidth: 140,
      imageHeight: 140,
      cx: 60,
      cy: 60,
      scale: 0.75,
      opacity: 0,
    },
    huntsman2: {
      id: 'huntsman',
      name: 'Vadász',
      gender: 'male',
      color: 'skyblue',
      imageX: 25,
      imageY: 10,
      imageWidth: 50,
      imageHeight: 100,
      cx: 97.5,
      cy: 82.5,
      scale: 0.3,
      opacity: 0,
    },
  },
  arrows: {},
}

export default graphData
